
    import "src/app/AppWms/Orders/index.module.scss?farm_css_modules";
    
    export default {"borderLessTag": `borderLessTag-1093d2bb`,"filterButton": `filterButton-1093d2bb`,"filterImage": `filterImage-1093d2bb`,"orderStatusFilter": `orderStatusFilter-1093d2bb`,"pickupAddress": `pickupAddress-1093d2bb`,"pickupDetails": `pickupDetails-1093d2bb`,"searchContainer": `searchContainer-1093d2bb`,"tag": `tag-1093d2bb`}
    